import React from 'react';

// Types
import {
  FormTypeType,
  ReviewFormTemplateType,
  RatingSummaryQuestionType,
  AdjectivesForPropertySummaryQuestionType,
  QuestionTypeType,
} from 'Shared/types/ReviewFormTemplate.type';

// Hooks
import { useQuestion } from './use-question';

// Components
import QuestionWrapper from './QuestionWrapper';
import WpSelectV2 from 'Wpds/components/select/WpSelectV2';

type Props = {
  question: RatingSummaryQuestionType | AdjectivesForPropertySummaryQuestionType;
  onChange: Function;
  handleDeleteQuestion: Function;
  handleDuplicateQuestion: Function;
  activeQuestionKey: string;
  setActiveQuestionKey: Function;
  handleMoveQuestion: Function;
  reviewFormType: FormTypeType;
  reviewFormTemplates: ReviewFormTemplateType[];
};

const SingleQuestionSummaryQuestion = ({
  question,
  onChange,
  handleDeleteQuestion,
  activeQuestionKey,
  setActiveQuestionKey,
  handleDuplicateQuestion,
  handleMoveQuestion,
  reviewFormType,
  reviewFormTemplates,
}: Props) => {
  const { handleUpdateQuestion } = useQuestion({ question, onChange });

  const isActive = activeQuestionKey === question.key;

  const peerReviewFormTemplate = reviewFormTemplates.find(({ formType }) => formType == FormTypeType.peer_review);
  const summarizedQuestionType = {
    [QuestionTypeType.RATING_SUMMARY]: QuestionTypeType.RATING,
    [QuestionTypeType.ADJECTIVES_FOR_PROPERTY_SUMMARY]: QuestionTypeType.ADJECTIVES_FOR_PROPERTY,
  }[question.type];

  const summarizedQuestionOptions = peerReviewFormTemplate.questions
    .filter(peerReviewQuestion => peerReviewQuestion.type === summarizedQuestionType)
    .map(peerReviewQuestion => ({
      label: peerReviewQuestion.header || 'Unnamed question',
      value: peerReviewQuestion.key,
    }));

  const handleUpdateSummarizedQuestionKey = value => {
    handleUpdateQuestion({ summarizedQuestionKey: value });
  };

  const summarizedQuestion = peerReviewFormTemplate.questions.find(
    peerReviewQuestion => peerReviewQuestion.key === question.summarizedQuestionKey
  );

  return (
    <QuestionWrapper
      question={question}
      reviewFormType={reviewFormType}
      reviewFormTemplates={reviewFormTemplates}
      onChange={handleUpdateQuestion}
      handleDeleteQuestion={handleDeleteQuestion}
      activeQuestionKey={activeQuestionKey}
      setActiveQuestionKey={setActiveQuestionKey}
      handleDuplicateQuestion={handleDuplicateQuestion}
      handleMoveQuestion={handleMoveQuestion}
    >
      {isActive && (
        <WpSelectV2
          id={`question_summarized_question_key_${question.key}`}
          label="Summarized Question"
          placeholder="Select peer review question to summarize"
          options={summarizedQuestionOptions}
          value={question.summarizedQuestionKey}
          forceReset
          onChange={handleUpdateSummarizedQuestionKey}
        />
      )}
      {!isActive && (
        <div>
          The user will be asked to summarize the responses to the &apos;{summarizedQuestion.header}&apos; question.
        </div>
      )}
    </QuestionWrapper>
  );
};

export default SingleQuestionSummaryQuestion;
